module.exports = __webpack_public_path__ + "static/media/pepsico-icon.98d7778f.png";